module.exports = __webpack_public_path__ + "static/cheetos-blue-c68d5250d45dffd74262353c14c77a20.png";